import { displayName } from '@xolv-mybrightlink/common';
import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Survey } from './models/Survey';
import { format } from 'date-fns';

type SurveyCardProps = {
  survey: Survey;
  backgroundUrl: string;
  handleOpenLink: (survey: Survey) => void;
};

export const surveyTitleByType: { [key in Survey['type']]: string } = {
  CSAT: 'csat.title',
  CLIENT_PACKET: 'client-packet.title',
  PSS: 'pss.title',
};
export const SurveyCard = ({
  survey,
  backgroundUrl,
  handleOpenLink,
}: SurveyCardProps) => {
  return (
    <Box
      sx={{
        position: 'relative',
        height: 100,
        flex: '0 0 340px',
      }}
    >
      <Box
        sx={{
          p: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          width: '100%',
          height: '100%',
          borderRadius: 3,
          overflow: 'hidden',
          backgroundImage: `url(${backgroundUrl})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          cursor: 'pointer',
          textDecoration: 'none',
          boxShadow: 4,
        }}
        onClick={() => handleOpenLink(survey)}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            backgroundColor: '#3e5264',
            px: 2,
            py: 1,
            borderBottomRightRadius: 10,
            maxWidth: 0.5,
          }}
        >
          <Typography
            color='info.main'
            fontWeight='500'
            sx={{
              fontSize: 10,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {displayName({
              firstName: survey.patientFirstName,
              lastName: survey.patientLastName,
            })}
          </Typography>
        </Box>
        <Typography color='info.main' fontWeight='500'>
          <FormattedMessage id={surveyTitleByType[survey.type]} />
        </Typography>
        {survey.expirationDate ? (
          <Box
            sx={{
              position: 'absolute',
              right: -2,
              top: -2,
              px: 4,
              py: 2,
              borderBottomLeftRadius: 12,
              backgroundColor: 'rgba(256, 256, 256, 0.85)',
            }}
          >
            <Typography color='#D00070' sx={{ fontSize: 10, fontWeight: 500 }}>
              <FormattedMessage
                id='csat.expireInDate'
                values={{ date: format(survey.expirationDate, 'M/dd/yy') }}
              />
            </Typography>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};
